import { useNavigate, useSearch } from "@tanstack/react-router";

import { TwoFactorVerifyStep } from "./TwoFactorVerifyStep";

/**
 * 2FA challenge page. BetterAuthLoginPage navigates a 2FA-enrolled user here once their password is
 * accepted; for social sign-in, the auth-service redirects them here after the OAuth callback (see
 * auth-service social-two-factor.ts). Either way the `two_factor` challenge cookie is already set, so
 * TwoFactorVerifyStep's verify call completes the sign-in.
 * @returns JSX.Element
 */
export function BetterAuthTwoFactorPage() {
  // Post-verification destination, threaded from the original sign-in and sanitised to an
  // internal path by the route's validateSearch. `strict: false` resolves it outside the route (tests).
  const { redirect } = useSearch({ strict: false });
  const navigate = useNavigate();

  const onVerified = () => {
    // Full navigation so the Rails app shell picks up the new Better Auth session.
    void navigate({ href: redirect ?? "/", reloadDocument: true });
  };

  return <TwoFactorVerifyStep onVerified={onVerified} />;
}
